import {http, HttpResponse} from 'msw';
import {SetupServerApi} from 'msw/lib/node';

import {CustomerResponseBodyV2} from '../types';

export const createSupplierCustomerMock = (
  id: string,
  tradeName: string
): CustomerResponseBodyV2 => ({
  id,
  discriminator: 'BUSINESS',
  source: null,
  foundingPerson: null,
  businessInfo: {
    id: `${id}-business-info`,
    businessInfo: {
      countryOfRegistrationCode: null,
      registrationNumber: null,
      vatNumber: null,
      tradeName,
      fileNumber: null,
    },
    address: null,
  },
  contacts: [],
  persons: [],
  primaryContactId: null,
  contractInformation: [],
  addresses: [],
  selfEmployed: null,
  selfEmployedBusinessInfoData: null,
  selfEmployedBusinessAddress: null,
  publicId: null,
  institutions: ['SUPPLIER'],
  customerGroups: [],
  abroadSale: null,
  preferredLocale: null,
});

const getSupplierCustomersResponseMock: CustomerResponseBodyV2[] = [
  createSupplierCustomerMock('a024ebfe-b790-47b2-ac85-da86ac458869', 'Hyundai Motor Czech s.r.o.'),
  createSupplierCustomerMock(
    'c5dd0275-2599-42fb-bf9d-f657a30e1e32',
    'Mercedes-Benz Česká republika s.r.o.'
  ),
];

const getSupplierCustomersResponseInterceptor = (
  server: SetupServerApi,
  customersAsSuppliers: CustomerResponseBodyV2[] = getSupplierCustomersResponseMock
) => server.use(http.get('*/dms/v2/customer', () => HttpResponse.json(customersAsSuppliers)));

export const customerSupplierApiMock = {
  getSupplierCustomersResponseMock,
  getSupplierCustomersResponseInterceptor,
};
